import { Box, Flex, Text, Skeleton, Button } from "@chakra-ui/react";
import { useDashboardReservasPendentes } from "core/features/dashboards/hooks/useDashboardReservasPendentes";
import { useDashboardPrincipal } from "core/features/dashboards/store";
import { useHistory } from "react-router-dom";
import { Empty } from "antd";
import CardItemReserva from "./CardItemReserva";

function CardReservaPendente() {
  const history = useHistory();
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useDashboardReservasPendentes({ ...query });

  return (
    <Box
      boxShadow="0 0 24px rgba(0,0,0,.05)"
      bg="white"
      rounded="16px"
      justifyContent="center"
      alignItems="center"
      p="24px"
      mt="16px"
    >
      <Flex mb={4}>
        <Text fontSize="20px">
          {data?.total === 1
            ? `${data.total} reserva de espaço pendente`
            : `${data?.total ?? 0} reservas de espaço pendentes`}
        </Text>
      </Flex>
      <Flex flexDir="column">
        {isFetching ? (
          <Box>
            <Skeleton mb="16px" w="100%" h="100px" />
            <Skeleton mb="16px" w="100%" h="100px" />
            <Skeleton w="100%" h="100px" />
          </Box>
        ) : null}

        {data?.items.map((reserva, index) => (
          <CardItemReserva key={reserva.id} item={reserva} />
        ))}

        {!isFetching && !data?.items.length ? (
          <Flex justifyContent="center" alignItems="center" flex={1}>
            <Empty />
          </Flex>
        ) : null}

        {data?.total! > 3 ? (
          <Button
            isFullWidth
            fontWeight="normal"
            onClick={() => history.push("/administracao/reservas")}
          >
            Ver mais
          </Button>
        ) : null}
      </Flex>
    </Box>
  );
}

export default CardReservaPendente;
